<template>
	<div id="app">
		<el-container>
			<el-header>
				<div v-if='$route.name != "error" && $route.name != "login"'>
					<!-- 头部 -->
					<v-header ref="vheader"></v-header>
				</div>
			</el-header>
			<el-main>
				<!-- 设置keepAlive为true的页面，页面被缓存，返回时不刷新 -->
				<keep-alive>
					<router-view v-if='$route.meta.keepAlive'></router-view>
				</keep-alive>
				<router-view v-if='!$route.meta.keepAlive && isRouterAlive'></router-view>
			</el-main>
		</el-container>
		<!-- 全局悬浮按钮组件，在所有页面显示（登录、错误页面除外） -->
		<float-btns v-if='$route.name != "error" && $route.name != "login"'></float-btns>
	</div>
</template>

<script>
	import vHeader from './components/common/Header.vue';
	import FloatBtns from './components/common/FloatBtns.vue';
	import {
		getAllParam,
		getParam
	} from './utils/api-utils/api-params.js';
	import {
		getCustomerInfo
	} from './utils/api-utils/api-customer.js';
	import { shouldShowPasswordSetup } from './utils/password-validator.js';
	import {
		getSubMallInfoList,
		getProductOrderInfo
	} from './utils/api-utils/api-auth.js';
	import { system } from './utils/api-utils/api-sys.js';
	export default {
		name: 'app',
		components: {
			'v-header': vHeader,
			'float-btns': FloatBtns
		},
		provide() { // 父组件中返回要传给下级的数据
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		async created() {
			// 游客态登录和商城版本获取已移至 main.js bootstrap（必须在 new Vue 之前完成）

			// 加载系统参数（含缓存清空，添加其他缓存需要在这步之后）
			await this.getSysParams();

			// 校验customerInfo信息
			this.checkCustomer();

			// 检测用户产品订购信息
			// 因为添加了游客态登录，所以这个请求稍微延后一些执行
			const self = this;
			window.setTimeout(()=>{
				self._checkProductOrder();
			},2000)
			// 保存用户自定义域名
			let params = this._getUrlParams();
			// 来源域名存在则需要保存到缓存
			localStorage.setItem("userRef", params.ref || "");
		},
		mounted() {
			// 监听BroadcastChannel消息 判断吉客号是否变更
			const channel = new BroadcastChannel("jmall-memberName");
			channel.addEventListener("message", (event) => {
				let curCustomerId = system.getCustomerId();

				let isNotLogin = curCustomerId === undefined;
				let isDifLoginer = curCustomerId !== event.data;
				let isCurLogout = curCustomerId === '' && event.data === '';

				!isCurLogout && (isNotLogin || isDifLoginer) && window.location.replace('#/login');
			});

			// 清理旧监听器（安全起见）
			window.removeEventListener('message', this.handleWechatMessage);
			// 监听微信扫码回调
			window.addEventListener('message', this.handleWechatMessage);
		},
		methods: {
			handleWechatMessage(e) {
				// 安全：验证 origin（推荐）
				if (e.origin !== 'https://jmall.jackyun.com') return;

				if (e.data && e.data.type === 'WECHAT_LOGIN_SUCCESS') {
					const { code, state } = e.data;

					this.$eventBus.$emit("setWxLoginCode", code);
				}
			},

			reload() {
				// header 变化之后更新数据
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},

			/**
			 * 获取系统配置参数，渠道仓库等
			 */
			async getSysParams() {
				let _this = this;

				// 清除配置缓存
				localStorage.removeItem('userSetting');

				// 首次进入刷新全库缓存参数
				await getAllParam(true);
				let paramList = await getParam("bindSaleChannelId,bindSaleChannelName,bindWarehouseId,defaultMemberGradeId,defaultMemberGradeName,commission_mode,pc_goodsDetailStyle,currencySymbol,pcmall_version,decimalKeepPlaces");
				if (paramList.bindSaleChannelId) {
					// 保存到缓存
					localStorage.setItem("pc_channelId", paramList.bindSaleChannelId);
					// 获取到店铺Id后，获取购物车总数
					this.$eventBus.$emit("updateHeaderShopCartCount");
				}

				// 绑定的吉客云渠道名称
				if (paramList.bindSaleChannelName) {
					// 保存到缓存
					localStorage.setItem("pc_channelName", paramList.bindSaleChannelName);
				}

				// 默认仓库ID
				if (paramList.bindWarehouseId) {
					// 保存到缓存
					localStorage.setItem("pc_warehouseId", paramList.bindWarehouseId);
				}

				// 默认会员等级ID
				if (paramList.defaultMemberGradeId) {
					// 保存到缓存
					localStorage.setItem("pc_defaultMemberGradeId", paramList.defaultMemberGradeId);
				}

				// 默认会员等级名称
				if (paramList.defaultMemberGradeName) {
					// 保存到缓存
					localStorage.setItem("pc_defaultMemberGradeName", paramList.defaultMemberGradeName);
				}

				// 分销模式
				localStorage.setItem('pc_commissionMode', paramList.commission_mode ? paramList
					.commission_mode : '');

				// 商品详情样式
				localStorage.setItem('pc_goodsDetailStyle', paramList.pc_goodsDetailStyle ? paramList
					.pc_goodsDetailStyle : 0);

				// 小数保留位数
				localStorage.setItem('decimalKeepPlaces', paramList.decimalKeepPlaces || 2);

				// 币种符号
				_this.$currency.setSymbol(paramList.currencySymbol || "￥");
			},

			// 校验customerInfo信息
			async checkCustomer() {
				// 获取缓存中信息
				if (!localStorage.getItem("pc_customerId")) {
					return;
				}

				// 用当前customerId查不到客户信息时退出登录
				let jmallCus = await getCustomerInfo({}, true);
				if (jmallCus.customerId) {
					if (shouldShowPasswordSetup(jmallCus)) {
						this.$eventBus.$emit("showLoginDialog", true, false, jmallCus);
					}
					return;
				}
				this.$refs.vheader.logout();
			},

			/**
			 * 检测用户产品订购信息
			 */
			async _checkProductOrder(checkId) {
				// 标识Id检测，防止线程重复执行（存在id需要检测，检测不通过则不执行，不存在则重新生成，说明是最新的调用）
				if (checkId) {
					let currCheckId = localStorage.getItem("productOrderCheckId");
					if (currCheckId != checkId) {
						return;
					}
				} else {
					// 生成标识Id
					checkId = new Date().getTime();
					localStorage.setItem("productOrderCheckId", checkId);
				}

				try {
					// 获取订购信息
					let productOrderInfo = await getProductOrderInfo();
					localStorage.setItem("productOrderInfo", JSON.stringify(productOrderInfo));
					if (!productOrderInfo.productCode) {
						throw new Error("未获取到产品订购信息");
					}
					if (productOrderInfo.isExpired) {
						throw new Error("产品订购已到期");
					}

					// 获取吉客号和子账号信息
					let memberName = localStorage.getItem("JackyunUserName");
					// 子商城名称 accountname
					let subMemberName = localStorage.getItem("SubMemberName");

					// 获取当前吉客号的子商信息
					let subMallInfoList = await getSubMallInfoList()||[];
					if (subMallInfoList&&subMallInfoList.length > 0) {
						// 当前小程序的商城信息
						let currMallInfo = subMallInfoList.find(t => t.accountName == (subMemberName || memberName));
						if (!currMallInfo) {
							throw new Error("未获取到当前商城注册信息");
						}
						if (currMallInfo.status == 0) {
							throw new Error("当前商城未开启");
						}
						// 缓存子商城名称 shopname
						localStorage.setItem("SubJmallName", currMallInfo.subJmallName);
					}
					// 清空异常信息
					localStorage.setItem("productOrderErrMsg", '');
				} catch (e) {
					// 需要阻断的错误类型：订购到期、商城未开启
					const BLOCK_ERROR_KEYWORDS = ['到期', '过期', '未开启', '未订阅'];
					const isBlockError = BLOCK_ERROR_KEYWORDS.some(keyword => errMsg.includes(keyword));
					if (isBlockError) {
						// 阻断性错误：到期、未开启等 - 设置错误信息并提示用户
						localStorage.setItem("productOrderErrMsg", e.message);
						// 产品要求统一提示“升级中”
						this.$message.error({
							message: this.$t("common.prompt.storeUpgrading")
						});
					}else{
						localStorage.setItem("productOrderErrMsg", '');
						// 非阻断错误，增加重试机制
						const MAX_RETRY = 2;
						const RETRY_DELAY = 3000; // 3秒
						let retryCount = 0;
						if (retryCount < MAX_RETRY) {
						console.log(`订购检测失败，${RETRY_DELAY / 1000}秒后重试（${retryCount + 1}/${MAX_RETRY}）`);
						setTimeout(() => {
							this._checkProductOrder(checkId, retryCount + 1);
						}, RETRY_DELAY);
						return;
						}
					}
				} finally {
					// 检测完成后设置定时器
					// 失败分支：30秒后重试；成功分支：10分钟后重试
					const isSuccess = !localStorage.getItem("productOrderErrMsg");
					const delay = isSuccess ? 10 * 60 * 1000 : 30 * 1000;
					setTimeout(() => {
						this._checkProductOrder(checkId);
					}, delay);
				}
			},

			/**
			 * 获取地址栏传参
			 */
			_getUrlParams() {
				try {
					let hash = window.location.hash;
					let queryIndex = hash.indexOf('?');

					// 如果没有参数，返回空对象
					if (queryIndex === -1) {
						return {};
					}

					let queryString = hash.slice(queryIndex + 1); // 提取 "ref=www.haoshun365.com&id=123"
					let params = new URLSearchParams(queryString);

					let result = {};
					params.forEach((val, key) => {
						result[key] = val || "";
					});

					return result;
				} catch (e) {
					return {};
				}
			},
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.el-header {
		width: 100%;
		height: 50px !important;
		padding: 0 !important;
	}

	.el-main {
		padding: 0 !important;
		position: relative;
	}

	.el-message-box__message p {
		word-break: break-all;
	}

	.el-message {
		min-width: unset !important;
		width: fit-content !important;
		padding: 15px 20px !important;
	}

	*::-webkit-scrollbar {
		width: 9px;
		height: 9px;
	}

	*::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: #c1c1c1;
	}

	*::-webkit-scrollbar-track {
		border-radius: 10px;
		background: #f1f1f1;
	}

	.min-scroll::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 5px !important;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 5px !important;
	}

	.min-scroll::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 10px !important;
		background: #c1c1c1 !important;
	}

	.min-scroll::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		border-radius: 10px !important;
		background: #f1f1f1 !important;
	}

	.el-message-box__title {
		font-size: 16px !important;
		text-align: center !important;
	}

	.text-ellipsis_oneline {
		white-space: nowrap;
		overflow: hidden;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	/* 全面隐藏浏览器自带的密码 eye 和清除按钮 */
	input[type="password"] {
		/* 针对 IE / Edge */
		-webkit-text-security: disc;
		/* 确保仍是密码点 */
	}
	
	/* 隐藏 Edge/IE 的 eye 图标 */
	input[type="password"]::-ms-reveal,
	input[type="password"]::-ms-clear {
		display: none !important;
	}
</style>